import React from 'react';
import { Colours } from '../theme';

export const HamburgerIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 448 512'
      height={'20'}
      {...props}
    >
      <path d='M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z' />
    </svg>
  );
};

export const KoperationIcon = () => {
  return (
    <svg
      width='24'
      height='21'
      viewBox='0 0 24 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.1275 3.93532L8.4975 6.92126C7.89375 7.41638 7.7775 8.30759 8.235 8.94362C8.71875 9.62155 9.66 9.75485 10.3088 9.24069L14.0325 6.30046C14.295 6.09479 14.67 6.1405 14.8763 6.4071C15.0825 6.6737 15.0338 7.05456 14.7713 7.26403L13.9875 7.88102L19.2 12.756V5.5654H19.1738L19.0275 5.47018L16.305 3.69919C15.7313 3.32595 15.06 3.1279 14.3775 3.1279C13.56 3.1279 12.765 3.41354 12.1275 3.93532ZM12.9825 8.67321L11.0438 10.2043C9.8625 11.1412 8.14875 10.8974 7.26375 9.66345C6.43125 8.50183 6.64125 6.87936 7.74 5.97673L10.86 3.41354C10.425 3.22692 9.95625 3.13171 9.48 3.13171C8.775 3.1279 8.08875 3.34118 7.5 3.73727L4.8 5.5654V14.0966H5.8575L9.285 17.273C10.02 17.9548 11.1563 17.9014 11.8275 17.1549C12.0338 16.9226 12.1725 16.6522 12.2438 16.3704L12.8813 16.9645C13.6125 17.6463 14.7525 17.5967 15.4238 16.8541C15.5925 16.6674 15.7163 16.4504 15.795 16.2257C16.5225 16.7208 17.5125 16.6179 18.1238 15.94C18.795 15.1973 18.7463 14.0395 18.015 13.3578L12.9825 8.67321ZM3.6 5.5654H0V14.0966C0 14.7708 0.53625 15.3154 1.2 15.3154H2.4C3.06375 15.3154 3.6 14.7708 3.6 14.0966V5.5654ZM1.8 14.0966C1.47 14.0966 1.2 13.8224 1.2 13.4873C1.2 13.1521 1.47 12.8779 1.8 12.8779C2.13 12.8779 2.4 13.1521 2.4 13.4873C2.4 13.8224 2.13 14.0966 1.8 14.0966ZM20.4 5.5654V14.0966C20.4 14.7708 20.9363 15.3154 21.6 15.3154H22.8C23.4638 15.3154 24 14.7708 24 14.0966V5.5654H20.4ZM22.8 13.4873C22.8 13.8224 22.53 14.0966 22.2 14.0966C21.87 14.0966 21.6 13.8224 21.6 13.4873C21.6 13.1521 21.87 12.8779 22.2 12.8779C22.53 12.8779 22.8 13.1521 22.8 13.4873Z'
        fill='#8DA8A8'
      />
    </svg>
  );
};

export const MitmachenIcon = () => {
  return (
    <svg
      width='20'
      height='16'
      viewBox='0 0 20 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4ZM0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5H8.42813C11.5063 9.5 14 11.9937 14 15.0719C14 15.5844 13.5844 16 13.0719 16H0.928125C0.415625 16 0 15.5844 0 15.0719ZM19.0406 16H14.7312C14.9 15.7063 15 15.3656 15 15V14.75C15 12.8531 14.1531 11.15 12.8188 10.0063C12.8938 10.0031 12.9656 10 13.0406 10H14.9594C17.7438 10 20 12.2562 20 15.0406C20 15.5719 19.5687 16 19.0406 16ZM13.5 8C12.5312 8 11.6563 7.60625 11.0219 6.97188C11.6375 6.14063 12 5.1125 12 4C12 3.1625 11.7938 2.37188 11.4281 1.67813C12.0094 1.25313 12.725 1 13.5 1C15.4344 1 17 2.56562 17 4.5C17 6.43438 15.4344 8 13.5 8Z'
        fill='#8DA8A8'
      />
    </svg>
  );
};

export const DatenschutzIcon = () => {
  return (
    <svg
      width='22'
      height='21'
      viewBox='0 0 22 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4_100)'>
        <path
          d='M0 2.99851C0 1.65024 1.09618 0.554062 2.44444 0.554062H8.55556V5.44295C8.55556 6.11899 9.10174 6.66517 9.77778 6.66517H14.6667V8.46031L11.1222 9.87733C10.3087 10.202 9.77778 10.9888 9.77778 11.8634C9.77778 14.0252 10.4997 17.5162 13.3757 19.8193C13.0319 20.0027 12.6385 20.1096 12.2222 20.1096H2.44444C1.09618 20.1096 0 19.0134 0 17.6652V2.99851ZM14.6667 5.44295H9.77778V0.554062L14.6667 5.44295ZM16.1601 9.17455C16.3778 9.0867 16.6222 9.0867 16.8399 9.17455L21.4233 11.0079C21.7708 11.1492 22 11.4853 22 11.8596C22 14.2773 21.0108 18.3068 16.8514 20.0409C16.626 20.1364 16.3701 20.1364 16.1448 20.0409C11.9892 18.3068 11 14.2773 11 11.8596C11 11.4853 11.2292 11.1492 11.5767 11.0079L16.1601 9.17455ZM20.1438 12.4707L16.5 11.0117V18.1884C19.1049 16.928 19.9948 14.4072 20.1438 12.4707Z'
          fill='#8DA8A8'
        />
      </g>
      <defs>
        <clipPath id='clip0_4_100'>
          <rect
            width='22'
            height='19.5556'
            fill='white'
            transform='translate(0 0.554062)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FinanzIcon = () => {
  return (
    <svg
      width='22'
      height='23'
      viewBox='0 0 22 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4_92)'>
        <path
          d='M14.0379 17.5369C13.0883 17.8806 12.0656 18.0654 11 18.0654C9.93438 18.0654 8.90742 17.8764 7.96211 17.5369C7.94922 17.5326 7.94063 17.5283 7.92773 17.524C6.63867 17.0514 5.48711 16.2908 4.55039 15.3154C3.00781 13.7084 2.0625 11.5299 2.0625 9.12791C2.0625 4.1908 6.06289 0.190414 11 0.190414C15.9371 0.190414 19.9375 4.1908 19.9375 9.12791C19.9375 11.5299 18.9922 13.7084 17.4496 15.3154C17.4066 15.3584 17.3637 15.4056 17.3207 15.4486C16.4012 16.3681 15.284 17.0857 14.0422 17.5369H14.0379ZM11 4.13924C10.523 4.13924 10.1363 4.52596 10.1363 5.00291V5.26073C9.8957 5.31229 9.66797 5.38534 9.45312 5.47987C8.80859 5.77205 8.2543 6.31346 8.1168 7.09979C8.03945 7.53807 8.08242 7.95916 8.26289 8.34588C8.44336 8.72401 8.72266 8.99041 9.00625 9.18377C9.50469 9.52323 10.1621 9.72088 10.6648 9.87127L10.7594 9.90135C11.3566 10.0818 11.7648 10.2193 12.0184 10.4041C12.1258 10.4814 12.1645 10.5416 12.1816 10.576C12.1945 10.6103 12.2203 10.6877 12.1902 10.8639C12.1645 11.0142 12.0828 11.1389 11.8465 11.242C11.5844 11.3537 11.159 11.4096 10.609 11.3236C10.3512 11.2806 9.89141 11.126 9.4832 10.9842C9.38867 10.9541 9.29844 10.9197 9.2082 10.8939C8.75703 10.7435 8.27148 10.9885 8.12109 11.4396C7.9707 11.8908 8.21562 12.3764 8.6668 12.5267C8.71836 12.5439 8.78281 12.5654 8.85586 12.5912C9.19531 12.7072 9.72812 12.8877 10.1363 12.9822V13.2529C10.1363 13.7299 10.523 14.1166 11 14.1166C11.477 14.1166 11.8637 13.7299 11.8637 13.2529V13.0166C12.0957 12.9736 12.3148 12.9092 12.5254 12.8189C13.2 12.531 13.7457 11.9724 13.8832 11.156C13.9605 10.7092 13.9262 10.2838 13.7543 9.89276C13.5867 9.50604 13.316 9.22245 13.0281 9.0119C12.5039 8.63377 11.8121 8.42323 11.2922 8.26424L11.2578 8.25565C10.6477 8.07088 10.2352 7.94198 9.97305 7.76581C9.86133 7.68846 9.82695 7.6369 9.81836 7.61541C9.80977 7.60252 9.78828 7.54666 9.81406 7.40057C9.82695 7.31893 9.8957 7.17713 10.1664 7.05252C10.4414 6.92791 10.8711 6.85916 11.3953 6.94081C11.5801 6.97088 12.1645 7.0826 12.3277 7.12557C12.7875 7.24588 13.2559 6.97518 13.3805 6.51541C13.5051 6.05565 13.2301 5.58729 12.7703 5.46268C12.5813 5.41112 12.1516 5.32518 11.868 5.27362V5.00291C11.868 4.52596 11.4813 4.13924 11.0043 4.13924H11ZM2.0625 15.3154H2.75C3.58789 16.4283 4.64062 17.365 5.85234 18.0654H2.75V19.4404H11H19.25V18.0654H16.1477C17.3594 17.365 18.4164 16.4283 19.25 15.3154H19.9375C21.0762 15.3154 22 16.2392 22 17.3779V20.1279C22 21.2666 21.0762 22.1904 19.9375 22.1904H2.0625C0.923828 22.1904 0 21.2666 0 20.1279V17.3779C0 16.2392 0.923828 15.3154 2.0625 15.3154Z'
          fill='#8DA8A8'
        />
        <rect
          x='6.28571'
          y='1.76184'
          width='7.85714'
          height='12.5714'
          fill='#8DA8A8'
        />
        <path
          d='M7.46673 8.44042C7.46428 8.50671 7.46428 8.57055 7.46428 8.63685V9.0297C7.46428 9.096 7.46428 9.15984 7.46673 9.22613H7.07142C6.63682 9.22613 6.28571 9.57725 6.28571 10.0118C6.28571 10.4464 6.63682 10.7976 7.07142 10.7976H7.76629C8.49307 12.8576 10.4598 14.3333 12.7678 14.3333H13.3571C13.7917 14.3333 14.1428 13.9822 14.1428 13.5476C14.1428 13.113 13.7917 12.7618 13.3571 12.7618H12.7678C11.3462 12.7618 10.1112 11.9663 9.48013 10.7976H12.5714C13.006 10.7976 13.3571 10.4464 13.3571 10.0118C13.3571 9.57725 13.006 9.22613 12.5714 9.22613H9.04062C9.03816 9.16229 9.03571 9.096 9.03571 9.0297V8.63685C9.03571 8.57055 9.03816 8.50426 9.04062 8.44042H12.5714C13.006 8.44042 13.3571 8.0893 13.3571 7.6547C13.3571 7.22011 13.006 6.86899 12.5714 6.86899H9.48013C10.1112 5.70024 11.3462 4.9047 12.7678 4.9047H13.3571C13.7917 4.9047 14.1428 4.55359 14.1428 4.11899C14.1428 3.68439 13.7917 3.33327 13.3571 3.33327H12.7678C10.4598 3.33327 8.49307 4.80894 7.76629 6.86899H7.07142C6.63682 6.86899 6.28571 7.22011 6.28571 7.6547C6.28571 8.0893 6.63682 8.44042 7.07142 8.44042H7.46673Z'
          fill='#FFFDFD'
        />
      </g>
      <defs>
        <clipPath id='clip0_4_92'>
          <rect
            width='22'
            height='22'
            fill='white'
            transform='translate(0 0.190414)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FunktionIcon = () => {
  return (
    <svg
      width='20'
      height='27'
      viewBox='0 0 20 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4_69)'>
        <path
          d='M14.1666 20.0237C14.6666 18.3623 15.7031 16.9456 16.7291 15.5342C17 15.1644 17.2708 14.7946 17.5312 14.4196C18.5625 12.9352 19.1666 11.1383 19.1666 9.19561C19.1666 4.1279 15.0625 0.023735 9.99998 0.023735C4.93748 0.023735 0.833313 4.1279 0.833313 9.1904C0.833313 11.1331 1.43748 12.9352 2.46873 14.4144C2.72915 14.7894 2.99998 15.1592 3.27081 15.5289C4.30206 16.9404 5.33852 18.3623 5.83331 20.0185H14.1666V20.0237ZM9.99998 26.6904C12.3021 26.6904 14.1666 24.8258 14.1666 22.5237V21.6904H5.83331V22.5237C5.83331 24.8258 7.6979 26.6904 9.99998 26.6904ZM5.83331 9.1904C5.83331 9.64873 5.45831 10.0237 4.99998 10.0237C4.54165 10.0237 4.16665 9.64873 4.16665 9.1904C4.16665 5.96644 6.77602 3.35707 9.99998 3.35707C10.4583 3.35707 10.8333 3.73207 10.8333 4.1904C10.8333 4.64873 10.4583 5.02373 9.99998 5.02373C7.6979 5.02373 5.83331 6.88832 5.83331 9.1904Z'
          fill='#8DA8A8'
        />
      </g>
      <defs>
        <clipPath id='clip0_4_69'>
          <rect
            width='20'
            height='26.6667'
            fill='white'
            transform='translate(0 0.023735)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Impressumicon = () => {
  return (
    <svg
      width='17'
      height='30'
      viewBox='0 0 17 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.3189 5.70104C4.45833 5.0358 4.89651 4.56555 5.71977 4.2444C6.63597 3.88885 8.03019 3.73401 9.78293 3.98634C10.3672 4.06663 12.1797 4.39351 12.7108 4.51967C13.8395 4.79494 15.0146 4.2272 15.3333 3.24655C15.6519 2.2659 14.9947 1.25658 13.8594 0.981313C13.1224 0.803534 11.1373 0.453713 10.48 0.361956C8.17625 0.0350738 5.87247 0.155504 3.97367 0.895291C1.9952 1.66949 0.508028 3.10892 0.122957 5.14476C0.116318 5.17344 0.109679 5.20785 0.109679 5.23652C-0.0363826 6.36627 0.129596 7.41 0.64745 8.33904C1.15867 9.26234 1.93545 9.94478 2.77198 10.4552C2.81182 10.4838 2.85829 10.5068 2.90476 10.5355C1.49062 11.3326 0.441637 12.5312 0.122957 14.1312C0.116318 14.1656 0.109679 14.1942 0.109679 14.2287C-0.0430217 15.3355 0.136236 16.3563 0.667368 17.2681C1.19186 18.1627 1.98192 18.8165 2.81182 19.3039C4.29899 20.1756 6.25754 20.6803 7.81774 21.0817L8.06339 21.1448C9.86924 21.6151 11.1772 21.9821 12.007 22.5097C12.3722 22.7391 12.5515 22.9455 12.6378 23.1348C12.7241 23.3183 12.8104 23.628 12.6975 24.1728C12.5847 24.752 12.1863 25.205 11.3232 25.5204C10.3937 25.8645 8.97295 26.0079 7.20694 25.7728C6.35712 25.6523 4.87659 25.2165 3.61515 24.8437C3.32967 24.7577 3.05082 24.6774 2.79854 24.6029C1.68316 24.2817 0.481472 24.8036 0.109679 25.767C-0.262114 26.7305 0.342049 27.7685 1.45743 28.0896C1.63005 28.1355 1.83586 28.1986 2.06823 28.2674C3.30311 28.6287 5.28822 29.2194 6.53638 29.3914H6.54966C8.84017 29.7011 11.1174 29.5864 13.0029 28.8925C14.9548 28.1699 16.4885 26.7993 16.8868 24.7921C17.1059 23.6853 17.013 22.6473 16.5549 21.7011C16.1366 20.8409 15.466 20.1871 14.7225 19.6824C15.8179 18.8853 16.6146 17.7785 16.8868 16.3448C17.0993 15.2093 17.013 14.1484 16.5681 13.1849C16.1233 12.2215 15.3864 11.4989 14.5631 10.9484C13.0494 9.93904 11.0045 9.37703 9.4045 8.94119L9.31155 8.91252C7.49242 8.41359 6.13803 8.03509 5.22847 7.47882C4.82348 7.22649 4.59775 6.99136 4.4716 6.76771C4.3521 6.55552 4.25915 6.23437 4.3189 5.70677V5.70104ZM9.41114 17.6581C9.39786 17.6523 9.38458 17.6523 9.3713 17.6466L9.27835 17.6236C7.45922 17.1534 6.0982 16.7921 5.18199 16.2588C4.77037 16.0179 4.56455 15.8057 4.45169 15.6107C4.3521 15.4387 4.25915 15.1692 4.31226 14.7104C4.43841 14.1541 4.83676 13.7183 5.67329 13.4086C6.60277 13.0645 8.02355 12.9211 9.79621 13.162L10.885 13.3111C11.3033 13.4774 11.6618 13.6552 11.9606 13.8559C12.3257 14.0968 12.5183 14.3261 12.6245 14.5555C12.7307 14.7849 12.8104 15.152 12.6975 15.7541C12.5382 16.5971 11.8477 17.2681 10.2344 17.5319L9.41114 17.6638V17.6581Z'
        fill='#8DA8A8'
      />
    </svg>
  );
};

export const Muticon = () => {
  return (
    <svg
      width='22'
      height='30'
      viewBox='0 0 22 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 11.3727C22 16.2137 15.2969 24.8322 12.3578 28.3881C11.6531 29.2356 10.3469 29.2356 9.64219 28.3881C6.70313 24.8322 0 16.2137 0 11.3727C0 5.50147 4.92708 0.738022 11 0.738022C17.0729 0.738022 22 5.50147 22 11.3727Z'
        fill='#8DA8A8'
      />
      <path
        d='M8.69174 11.1472L8.65001 11.0544C8.46986 10.6539 7.87282 10.7179 7.78467 11.1472L6.98117 15.132C6.91309 15.4696 6.61185 15.7128 6.26181 15.7128C5.79708 15.7128 5.44954 15.2932 5.54365 14.8458L7.40036 6.01851C7.41129 5.96654 7.45784 5.92927 7.51181 5.92927C7.55462 5.92927 7.59382 5.9529 7.61323 5.99042L10.3164 11.2137C10.632 11.9015 11.6254 11.9015 11.941 11.2137L14.5928 5.9861C14.6104 5.95128 14.6466 5.92927 14.6862 5.92927C14.7354 5.92927 14.7779 5.96305 14.7882 6.01034L16.7202 14.8464C16.8176 15.2922 16.472 15.7128 16.0082 15.7128C15.6652 15.7128 15.3687 15.4775 15.2964 15.1478L14.4185 11.1472C14.3307 10.7391 13.7563 10.6941 13.604 11.0835L13.5791 11.1472L11.188 15.6774C11.1765 15.6992 11.1536 15.7128 11.1287 15.7128C11.1037 15.7128 11.0809 15.6991 11.0694 15.6773L8.69174 11.1472Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.39535 12.3966L7.81117 15.2938C7.66455 16.0209 7.01573 16.5447 6.26181 16.5447C5.26086 16.5447 4.51232 15.641 4.71503 14.6773L6.57174 5.85002C6.66393 5.41171 7.05657 5.09734 7.51181 5.09734C7.87298 5.09734 8.20359 5.29666 8.36738 5.61315L11.0705 10.8364L10.3164 11.2137L7.61323 5.99042C7.59382 5.9529 7.55462 5.92927 7.51181 5.92927C7.45784 5.92927 7.41129 5.96654 7.40036 6.01851L5.54365 14.8458C5.44954 15.2932 5.79708 15.7128 6.26181 15.7128C6.61185 15.7128 6.91309 15.4696 6.98117 15.132L7.78467 11.1472C7.87282 10.7179 8.46986 10.6539 8.65001 11.0544L8.69174 11.1472L11.0694 15.6773C11.0809 15.6991 11.1037 15.7128 11.1287 15.7128C11.1536 15.7128 11.1765 15.6992 11.188 15.6774L13.5791 11.1472L13.604 11.0835C13.7563 10.6941 14.3307 10.7391 14.4185 11.1472L15.2964 15.1478C15.3687 15.4775 15.6652 15.7128 16.0082 15.7128C16.472 15.7128 16.8176 15.2922 16.7202 14.8464L14.7882 6.01034C14.7779 5.96305 14.7354 5.92927 14.6862 5.92927C14.6466 5.92927 14.6104 5.95128 14.5928 5.9861L11.941 11.2137C11.6254 11.9015 10.632 11.9015 10.3164 11.2137L11.0877 10.8716C11.0926 10.8824 11.0978 10.8884 11.0978 10.8884L11.1017 10.8916C11.1051 10.8937 11.1144 10.8976 11.1287 10.8976C11.1429 10.8976 11.1522 10.8937 11.1557 10.8916L11.1596 10.8884C11.1596 10.8884 11.1647 10.8824 11.1697 10.8716L11.1764 10.8569L13.8356 5.6148C13.9964 5.29772 14.3258 5.09734 14.6862 5.09734C15.1342 5.09734 15.5213 5.40488 15.6155 5.8355L17.5474 14.6715C17.7581 15.6354 17.0109 16.5447 16.0082 16.5447C15.2667 16.5447 14.6256 16.036 14.4693 15.3233L13.8405 12.458L11.939 16.0606C11.782 16.3581 11.4696 16.5447 11.1287 16.5447C10.7871 16.5447 10.4741 16.3572 10.3175 16.0588L8.39535 12.3966Z'
        fill='white'
      />
    </svg>
  );
};

export const WerIstMutIcon = () => {
  return (
    <svg
      width='22'
      height='23'
      viewBox='0 0 22 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4_64)'>
        <path
          d='M11 22.0237C17.0758 22.0237 22 17.0995 22 11.0237C22 4.94795 17.0758 0.023735 11 0.023735C4.92422 0.023735 0 4.94795 0 11.0237C0 17.0995 4.92422 22.0237 11 22.0237ZM9.28125 14.4612H10.3125V11.7112H9.28125C8.70977 11.7112 8.25 11.2515 8.25 10.68C8.25 10.1085 8.70977 9.64874 9.28125 9.64874H11.3438C11.9152 9.64874 12.375 10.1085 12.375 10.68V14.4612H12.7188C13.2902 14.4612 13.75 14.921 13.75 15.4925C13.75 16.064 13.2902 16.5237 12.7188 16.5237H9.28125C8.70977 16.5237 8.25 16.064 8.25 15.4925C8.25 14.921 8.70977 14.4612 9.28125 14.4612ZM11 8.27374C10.2395 8.27374 9.625 7.65928 9.625 6.89874C9.625 6.13819 10.2395 5.52374 11 5.52374C11.7605 5.52374 12.375 6.13819 12.375 6.89874C12.375 7.65928 11.7605 8.27374 11 8.27374Z'
          fill='#8DA8A8'
        />
      </g>
      <defs>
        <clipPath id='clip0_4_64'>
          <rect
            width='22'
            height='22'
            fill='white'
            transform='translate(0 0.023735)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ContactIcon = () => {
  return (
    <svg
      width='22'
      height='18'
      viewBox='0 0 22 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.44444 0.359619C1.09618 0.359619 0 1.48071 0 2.85962V15.3596C0 16.7385 1.09618 17.8596 2.44444 17.8596H19.5556C20.9038 17.8596 22 16.7385 22 15.3596V2.85962C22 1.48071 20.9038 0.359619 19.5556 0.359619H2.44444ZM5.5 10.3596H7.94444C9.63264 10.3596 11 11.7581 11 13.4846C11 13.8284 10.725 14.1096 10.3889 14.1096H3.05556C2.71944 14.1096 2.44444 13.8284 2.44444 13.4846C2.44444 11.7581 3.81181 10.3596 5.5 10.3596ZM4.27778 6.60962C4.27778 5.94658 4.53532 5.31069 4.99374 4.84185C5.45216 4.37301 6.07392 4.10962 6.72222 4.10962C7.37053 4.10962 7.99228 4.37301 8.45071 4.84185C8.90913 5.31069 9.16667 5.94658 9.16667 6.60962C9.16667 7.27266 8.90913 7.90855 8.45071 8.37739C7.99228 8.84623 7.37053 9.10962 6.72222 9.10962C6.07392 9.10962 5.45216 8.84623 4.99374 8.37739C4.53532 7.90855 4.27778 7.27266 4.27778 6.60962ZM14.0556 5.35962H18.9444C19.2806 5.35962 19.5556 5.64087 19.5556 5.98462C19.5556 6.32837 19.2806 6.60962 18.9444 6.60962H14.0556C13.7194 6.60962 13.4444 6.32837 13.4444 5.98462C13.4444 5.64087 13.7194 5.35962 14.0556 5.35962ZM14.0556 7.85962H18.9444C19.2806 7.85962 19.5556 8.14087 19.5556 8.48462C19.5556 8.82837 19.2806 9.10962 18.9444 9.10962H14.0556C13.7194 9.10962 13.4444 8.82837 13.4444 8.48462C13.4444 8.14087 13.7194 7.85962 14.0556 7.85962ZM14.0556 10.3596H18.9444C19.2806 10.3596 19.5556 10.6409 19.5556 10.9846C19.5556 11.3284 19.2806 11.6096 18.9444 11.6096H14.0556C13.7194 11.6096 13.4444 11.3284 13.4444 10.9846C13.4444 10.6409 13.7194 10.3596 14.0556 10.3596Z'
        fill='#8DA8A8'
      />
    </svg>
  );
};

export const HeadsetIcon = () => {
  return (
    <svg
      width='22'
      height='18'
      viewBox='0 0 512 512'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z'
        fill='#8DA8A8'
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 26 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='rgba(64, 155,162,1)'
        d='M25.9932 11.9766C25.9932 12.8203 25.316 13.4813 24.5486 13.4813H23.104L23.1356 20.9906C23.1356 21.1172 23.1266 21.2438 23.1131 21.3703V22.125C23.1131 23.1609 22.305 24 21.3074 24H20.5851C20.5354 24 20.4858 24 20.4361 23.9953C20.3729 24 20.3097 24 20.2465 24H18.7794H17.6959C16.6983 24 15.8902 23.1609 15.8902 22.125V21V18C15.8902 17.1703 15.2447 16.5 14.4457 16.5H11.5565C10.7575 16.5 10.112 17.1703 10.112 18V21V22.125C10.112 23.1609 9.30392 24 8.30626 24H7.22284H5.78278C5.71507 24 5.64736 23.9953 5.57964 23.9906C5.52547 23.9953 5.4713 24 5.41713 24H4.69484C3.69719 24 2.88913 23.1609 2.88913 22.125V16.875C2.88913 16.8328 2.88913 16.7859 2.89365 16.7438V13.4813H1.44457C0.631998 13.4813 0 12.825 0 11.9766C0 11.5547 0.135428 11.1797 0.451427 10.8516L12.026 0.375C12.342 0.046875 12.7032 0 13.0192 0C13.3352 0 13.6963 0.09375 13.9672 0.328125L25.4966 10.8516C25.8578 11.1797 26.0383 11.5547 25.9932 11.9766Z'
      />
    </svg>
  );
};

export const DirectionIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.113 7.86553L14.113 7.86559L16.5055 10.4951C16.5055 10.4952 16.5056 10.4952 16.5056 10.4953C16.6038 10.6024 16.6564 10.749 16.6564 10.8992C16.6564 11.0493 16.6038 11.1959 16.5056 11.3031C16.5056 11.3031 16.5055 11.3031 16.5055 11.3032L14.113 13.9327L14.113 13.9328C13.9687 14.091 13.7514 14.1388 13.5622 14.0437C13.377 13.9507 13.2661 13.7443 13.2661 13.529L13.2661 11.9273L10.1759 11.9273C9.95068 11.9273 9.74415 12.1443 9.74415 12.4461L9.74415 13.993C9.74415 14.3758 9.47546 14.7118 9.11244 14.7118L8.58073 14.7118C8.21771 14.7118 7.94902 14.3758 7.94902 13.993L7.94902 12.4461C7.94902 11.0385 8.93219 9.87098 10.1759 9.87098L13.2661 9.87098L13.2661 8.26935C13.2661 8.05181 13.3772 7.84753 13.5622 7.75458C13.7514 7.6595 13.9687 7.70726 14.113 7.86553Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.2'
      />
      <rect
        x='1.41421'
        width='17.5563'
        height='17.5563'
        rx='4'
        transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 25.4142 13)'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  );
};

export const OsmIcon = () => {
  return (
    <svg
      width='31'
      height='24'
      viewBox='0 0 31 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.2105 23.9925L10.1053 21.0012V0.00753512L20.2105 2.99884V23.9925ZM21.8947 23.9271V2.86807L28.5842 0.0947133C29.4158 -0.248551 30.3158 0.383491 30.3158 1.30976V19.5518C30.3158 20.0858 30 20.5653 29.5211 20.7669L21.8947 23.9216V23.9271ZM0.794737 3.23313L8.42105 0.0783674V21.1319L1.73158 23.9053C0.9 24.2485 0 23.6165 0 22.6902V4.44818C0 3.91421 0.315789 3.43473 0.794737 3.23313Z'
        fill='white'
      />
      <path
        d='M7.11797 20.0635L7.1179 20.0636C6.58851 20.5929 5.72906 20.5929 5.19967 20.0636C4.67025 19.5343 4.67025 18.6749 5.19967 18.1456L9.42349 13.9193C8.60156 12.7226 8.11769 11.2727 8.11769 9.70953C8.11769 5.6034 11.4454 2.27637 15.5523 2.27637C19.6591 2.27637 22.9868 5.6034 22.9868 9.70953C22.9868 13.8156 19.6591 17.1427 15.5523 17.1427C13.9892 17.1427 12.5389 16.6623 11.3415 15.8375L7.11797 20.0635ZM13.7445 14.073C14.3176 14.3103 14.9319 14.4325 15.5523 14.4325C16.1726 14.4325 16.7869 14.3103 17.36 14.073C17.9332 13.8356 18.4539 13.4877 18.8926 13.0491C19.3312 12.6106 19.6792 12.0899 19.9166 11.5169C20.154 10.9439 20.2762 10.3297 20.2762 9.70953C20.2762 9.0893 20.154 8.47516 19.9166 7.90214C19.6792 7.32913 19.3312 6.80848 18.8926 6.36991C18.4539 5.93134 17.9332 5.58344 17.36 5.34609C16.7869 5.10874 16.1726 4.98657 15.5523 4.98657C14.9319 4.98657 14.3176 5.10874 13.7445 5.34609C13.1713 5.58344 12.6506 5.93134 12.2119 6.36991C11.7733 6.80848 11.4253 7.32913 11.1879 7.90214C10.9505 8.47516 10.8283 9.0893 10.8283 9.70953C10.8283 10.3297 10.9505 10.9439 11.1879 11.5169C11.4253 12.0899 11.7733 12.6106 12.2119 13.0491C12.6506 13.4877 13.1713 13.8356 13.7445 14.073Z'
        fill={Colours._darkGreen}
        stroke={Colours._darkGreen}
        strokeWidth='0.5'
      />
    </svg>
  );
};

export const ExternalLinkIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 2H14V6'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66669 9.33333L14 2'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
